import {
    MDBAlert,
    MDBBtn,
    MDBDatatable,
    MDBIcon,
    MDBInput
} from 'mdb-react-ui-kit';
import React, { useEffect, useRef, useState } from 'react';
import { useTranslation } from "react-i18next";
import PopupLoader from "../popups/PopupLoader";
import AddRemoveNum from '../popups/callblocking/AddRemoveNum';
import DeleteCallBlocking from '../popups/callblocking/DeleteCallBlocking';
import { formattedNumber } from '../popups/phonenumbers/AddRemoveNumbers';
import { Tooltip } from 'react-tooltip';
import PopupLoaderNew from '../popups/PopupLoaderNew';
import { customSearch, useAutoFocusSearchAfterLoads } from '../../components/CustomSearchUtil/CustomSearch';
import UIConstant from '../../apiclients/UIConstant';

function CallBlockingWhiteList(props) {
    const [selectedRegion, setSelectedRegion] = useState("IN");
    const { t, i18n } = useTranslation();
    const [AddNubers, setAddNubers] = useState(false);
    const toggleOpen = () => setAddNubers(!AddNubers);
    const [DeleteNuber, setDeleteNuber] = useState(false);
    const toggleOpen2 = () => setDeleteNuber(!DeleteNuber);
    const [whiteList, setWhiteList] = useState([]);
    const [whiteListObj, setWhiteListObj] = useState({});
    const [addEditWhiteFlag, setAddEditWhiteFlag] = useState(false);
    const [modifiedWhiteObj, setModifiedWhiteObj] = useState({});
    const [successMessageW, setSuccessMessageW] = useState("");
    const [messageW, setMessageW] = useState(false);
    const [isEditW, setIsEditW] = useState(false);
    const [wUniqueId, setWUniqueId] = useState(0);
    const [deleteWRowFlag, setDeleteWRowFlag] = useState(false);
    const addWhiteListRef = useRef(null);
    const [isLoading, setisLoading] = useState(false);
    const [searchValue, setSearchValue] = useState("");
    const [filteredRows, setFilteredRows] = useState([]);
    const [whiteListDetails, setWhiteListDetails] = useState([]);
    const [dataLoaded, setDataLoaded] = useState(false);
    const searchRef = useRef(null);
    function handleClick() {
        addWhiteListRef.current.click();
    }
useAutoFocusSearchAfterLoads(dataLoaded,setDataLoaded ,searchRef,props.isActive)
    useEffect(() => {
        if (successMessageW) {
            setMessageW(true);
            setTimeout(() => {
                setMessageW(false);
                setSuccessMessageW(""); // Clear the success message in the parent component
            }, 5000);
        }
    }, [successMessageW]);

    useEffect(() => {
        if (deleteWRowFlag) {
            const updateList = whiteList.filter((item) => item.unique_id != wUniqueId);
            setWhiteList(updateList);
            setDeleteWRowFlag(false);
        }
    }, [deleteWRowFlag]);

    useEffect(() => {
        if (props?.blockList && props?.blockList?.white_list && props?.blockList?.white_list.length > 0) {
            const tempList = props?.blockList?.white_list.map((num) => ({
                ...num,
                ph_number: formattedNumber(num.ph_number),
                phonenumber: num.ph_number,
                // split(',')
                // .map(phone => formattedNumber(phone))
                // .join(', ')
            }));
            setWhiteList(tempList);
        } else {
            setWhiteList([]);
        }

    }, [props.blockList]);

    useEffect(() => {
        if (Object.keys(modifiedWhiteObj).length > 0 && addEditWhiteFlag) {
            if (modifiedWhiteObj.isEdited) {
                sendEditApiRequest(modifiedWhiteObj);
            } else {
                sendAddApiRequest(modifiedWhiteObj);
            }
            setAddEditWhiteFlag(false);
        }

    }, [modifiedWhiteObj, addEditWhiteFlag]);

    async function sendAddApiRequest(modifiedObj) {
        try {
            setWhiteList([...whiteList, modifiedObj]);
        } catch (error) {

        }
    }

    async function sendEditApiRequest(modifiedObj) {
        try {
            delete modifiedObj.isEdited;
            // Filter out the existing object from whiteList and add the updated existObj
            setWhiteList(prev => {
                const newList = [...prev];              
                const index = newList.findIndex(item => item.unique_id === modifiedObj.unique_id);
                if (index !== -1) {
                    newList[index] = { ...modifiedObj };  
                }
                return newList;                        
            });
        } catch (error) {

        }
    }
    function handleAdd() {
        setWhiteListObj({
        })
        setIsEditW(false);
        toggleOpen();
    }
    const handleEdit = (whiteObj) => {
        setWhiteListObj({
            id: whiteObj.unique_id,
            ph_number: whiteObj.ph_number,
            comment: whiteObj.comment
        })
        setIsEditW(true);
        toggleOpen();
    }

    const handleWDelete = (uniqueid) => {
        setWUniqueId(uniqueid);
        toggleOpen2();


    }

    useEffect(()=>{
    let proccessdRows = [];
    whiteList.map((number) => {
        let phNumber = number.ph_number ? formattedNumber(number.ph_number) + "" : ""
        proccessdRows.push({
            unique_id: number?.unique_id ?? "",
            actualNumber: phNumber?.toString()?.replace(/[ ]/g, '') ?? "",
            ph_number: number.ph_number ?? "",
            phonenumber: number.phonenumber ?? "",
            created_date: number.created_date ?? "",
            // created_date_Ac: number.created_date?.toString()?.replace(/[-:\s]/g, "") ?? "",
            comment: number.comment ?? "",

            action: (
                <>
                    {/* <MDBIcon fas icon="times" title="Remove" color='primary' className='ms-3 cursor-pointer' onClick={(e) => {
                        e.preventDefault();
                        e.stopPropagation();
                        handleWDelete(number.unique_id);
                    }


                    } /> */}


                    <div className="d-flex align-items-center justify-content-center">
                        <div className="custom-hover-bg p-1 cursor-pointer deleteToolTip" onClick={(e) => {
                            e.preventDefault();
                            e.stopPropagation();
                            handleWDelete(number.unique_id);
                        }}>
                            <MDBIcon fas icon="times" color="primary" className="mx-2 fs-5" />
                        </div>
                    </div>
                </>
            )
        });
    });
    setFilteredRows(proccessdRows);
    setWhiteListDetails(proccessdRows)
    setDataLoaded(true)
    },[whiteList])

    const actionData = {
        columns: [
            { label: 'Numbers', field: 'ph_number', sort: true },
            { label: 'Comments', field: 'comment' },
            { label: 'Added On', field: 'created_date' },
            { label: 'Remove', field: 'action', sort: false },
        ],
        rows: whiteListDetails,
    };
 const handleManualSearch = (searchValue) =>{
    setSearchValue(searchValue); 
    const filtered = customSearch(whiteListDetails, searchValue, UIConstant.CALL_BLOCKING_WHITE_LIST);
  
    setFilteredRows(filtered);
  };

    return (
        <>
            <div>
                <div className="d-flex justify-content-between actionbar">
                    <div className="input-group w-25"></div>
                    <div>
                        <MDBBtn onClick={handleAdd}><MDBIcon fas icon="plus" className="me-2" />{t("add_Numbers")}</MDBBtn>
                    </div>
                </div> <div className='mb-2 mt-0 position-relative w-auto'>
                    <MDBInput
                        label="Search"
                        ref={searchRef}
                        value={searchValue}
                        onChange={(e) => handleManualSearch(e.target.value)}
                    />
                    <MDBIcon fas icon="search" className='MDBDatatable-Search' />
                </div>
                <div className="whitelistDatatable">
                    <MDBDatatable className='actioncolumn'
                        key={searchValue}
                        // search
                        fixedHeader
                        sortField="Numbers"
                        entries={50}
                        data={{...actionData,rows:filteredRows}}
                        onRowClick={(event) => {
                            handleEdit(event)
                        }} />

                </div>
            </div>
            {AddNubers && (
                <PopupLoaderNew
                    // className="modal-lg"
                    title={isEditW ? t('editWhitelistNumbers') : t('addwhitelistNumbers')}
                    content={
                        <AddRemoveNum
                            ListObj={whiteListObj}
                            modifyFlag={setAddEditWhiteFlag}
                            modifiedObj={setModifiedWhiteObj}
                            setSuccessMessage={setSuccessMessageW}
                            fieldname="whitelist_phnum"
                            editEnable={isEditW}
                            onClose={toggleOpen}
                            ref={addWhiteListRef}
                            setIsloading={setisLoading}
                        />
                    }
                    onShow={setAddNubers}
                    onClose={toggleOpen}
                    onSave={handleClick}
                    isloading={isLoading}
                    flag={isEditW ? 2 : 1}
                />
            )}
            {DeleteNuber && (
                <PopupLoaderNew
                    title={t('removenumbers')}
                    content={
                        <DeleteCallBlocking
                            rowUniq={wUniqueId}
                            onClose={toggleOpen2}
                            isWhiteList={true}
                            deleteRowFlag={setDeleteWRowFlag}
                            setSuccessMessage={setSuccessMessageW}
                            ref={addWhiteListRef}
                            setIsloading={setisLoading}
                        />
                    }
                    onShow={setDeleteNuber}
                    onClose={toggleOpen2}
                    onSave={handleClick}
                    isloading={isLoading}
                    flag={4}
                />
            )}

            {successMessageW && (
                <MDBAlert
                    open
                    className="alert-center"
                    color="success"
                    autohide
                    position="bottom-right"
                    delay={10000}
                >
                    <i className="fas fa-check-circle me-3"></i>
                    <span className="alert-msg">{successMessageW}</span>
                </MDBAlert>
            )}

            <Tooltip anchorSelect=".deleteToolTip" place="top" className="exampleTooltip">
                Remove
            </Tooltip>
        </>
    )
}
export default CallBlockingWhiteList;
